import {inject, Injectable} from '@angular/core';
import {EventSummaries} from './models';

import {Database, objectVal, ref} from '@angular/fire/database';
import {Observable, startWith, tap} from 'rxjs';

import ftcEventSummariesSeed from '../data/event-summaries-seed.ftc.json';
import frcEventSummariesSeed from '../data/event-summaries-seed.json';
import {PROGRAM} from './program.utils';

const LOCAL_STORAGE_KEY = 'nexus-event-summaries';

@Injectable({
  providedIn: 'root',
})
export class EventSummariesService {
  private readonly database = inject(Database);
  private readonly program = inject(PROGRAM);

  get(): Observable<EventSummaries> {
    return objectVal<EventSummaries>(ref(this.database, `eventSummaries`)).pipe(
      tap(d => this.update(d)),
      startWith(this.getCache()),
    );
  }

  getCache(): EventSummaries {
    const seed = (this.program === 'FTC' ? ftcEventSummariesSeed : frcEventSummariesSeed) as unknown as EventSummaries;

    let cache: EventSummaries|undefined;
    try {
      cache = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY) || 'null') || {};
    } catch(e) {}

    if(!cache || typeof cache !== 'object') {
      cache = {};
    }

    return {...seed, ...cache};
  }

  private update(data: EventSummaries) {
    setTimeout(() => {
      try {
        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
      } catch(e) {}
    });
  }
}
